
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6083',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6083",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7692",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11132",
  "I18n": "static-7.1543",
  "jasmine-runner": "static-1.6163",
  "quartz": "static-1.6592",
  "quartz-core": "static-1.5811",
  "react-dlb": "static-1.70",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.702",
  "enviro": "static-4.387",
  "foundations-components": "static-1.7331",
  "history": "static-4.47",
  "hub-http": "static-1.5872",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11440",
  "icons": "static-2.614",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6852",
  "PortalIdParser": "static-2.349",
  "quartz-config": "static-1.370",
  "quick-fetch": "static-1.3645",
  "react": "static-7.176",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16341",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5093",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18223",
  "signup-ui-lego-core": "static-1.20233",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "ui-addon-react-router-dom": "static-1.9255",
  "ui-images": "static-2.1063",
  "UIComponents": "static-3.8079",
  "usage-tracker": "static-1.7044",
  "usage-tracker-core": "static-1.6894",
  "viral-links-lib": "static-1.6729",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9346",
  "bend-plugin-trellis-migration": "static-1.3144",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2869",
  "quartz-webpack": "static-1.2816",
  "HeadJS": "static-2.692",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2803",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "foundations-theming": "static-1.4113",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4039",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.772",
  "hubspotter-http": "static-1.4395",
  "mobile-manifest-mixins": "static-1.464",
  "quartz-auth": "static-1.267",
  "quartz-head": "static-1.257",
  "quartz-i18n": "static-1.267",
  "quartz-test": "static-1.267",
  "usage-tracker-container": "static-1.7034",
  "ui-fonts": "static-1.394",
  "sassPrefix": "static-1.150",
  "bend-plugin-foundations-components": "static-1.3600",
  "floating-ui": "static-1.50",
  "foundations-assets": "static-1.4540",
  "foundations-theming-specialty": "static-1.1829",
  "hs-story-utils": "static-1.9136",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.993",
  "superstore": "static-1.4481",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4315",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7740",
  "bender-build-tools": "static-1.2823",
  "bend-plugin-foundations-theming": "static-1.2596",
  "foundations-theming-base": "static-1.3098",
  "stylex": "static-1.26",
  "hub-http-shared-msw-handlers": "static-1.9235",
  "hubspotter-http-shared-msw-handlers": "static-1.9233",
  "ts-schema": "static-1.3821"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6083",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7692",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11132",
  "I18n": "/I18n/static-7.1543",
  "jasmine-runner": "/jasmine-runner/static-1.6163",
  "quartz": "/quartz/static-1.6592",
  "quartz-core": "/quartz-core/static-1.5811",
  "react-dlb": "/react-dlb/static-1.70",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.702",
  "enviro": "/enviro/static-4.387",
  "foundations-components": "/foundations-components/static-1.7331",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11440",
  "icons": "/icons/static-2.614",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6852",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "quartz-config": "/quartz-config/static-1.370",
  "quick-fetch": "/quick-fetch/static-1.3645",
  "react": "/react/static-7.176",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16341",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5093",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18223",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20233",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9255",
  "ui-images": "/ui-images/static-2.1063",
  "UIComponents": "/UIComponents/static-3.8079",
  "usage-tracker": "/usage-tracker/static-1.7044",
  "usage-tracker-core": "/usage-tracker-core/static-1.6894",
  "viral-links-lib": "/viral-links-lib/static-1.6729",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9346",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3144",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2869",
  "quartz-webpack": "/quartz-webpack/static-1.2816",
  "HeadJS": "/HeadJS/static-2.692",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2803",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "foundations-theming": "/foundations-theming/static-1.4113",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4039",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.772",
  "hubspotter-http": "/hubspotter-http/static-1.4395",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.464",
  "quartz-auth": "/quartz-auth/static-1.267",
  "quartz-head": "/quartz-head/static-1.257",
  "quartz-i18n": "/quartz-i18n/static-1.267",
  "quartz-test": "/quartz-test/static-1.267",
  "usage-tracker-container": "/usage-tracker-container/static-1.7034",
  "ui-fonts": "/ui-fonts/static-1.394",
  "sassPrefix": "/sassPrefix/static-1.150",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3600",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-assets": "/foundations-assets/static-1.4540",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1829",
  "hs-story-utils": "/hs-story-utils/static-1.9136",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.993",
  "superstore": "/superstore/static-1.4481",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4315",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7740",
  "bender-build-tools": "/bender-build-tools/static-1.2823",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2596",
  "foundations-theming-base": "/foundations-theming-base/static-1.3098",
  "stylex": "/stylex/static-1.26",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9235",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9233",
  "ts-schema": "/ts-schema/static-1.3821"
}
};
